import React from 'react';
import axios from 'axios';
import { config } from '../../../app/config';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert } from '../../../actions';
import TranslationService from "../../../app/services/TranslationService";
import {Button} from "../../icymat-design/Button";
import {Label} from "../../icymat-design/Label";
import {FormGroup} from "../../icymat-design/FormGroup";


export class FinanceSettings extends React.Component {
    /**
     * @param props
     */
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            categories: [],
            newCategory: ''
        }
    }

    /**
     * @param prevProps
     * @param prevState
     */
    componentDidUpdate(prevProps, prevState) {
        if (!this.state.loaded && this.props.view === 'finance') {
            this.loadCategories();
        }
    };

    /**
     * Load events for week
     */
    loadCategories = () => {
        this.props.preloaderShow();
        let that = this;

        axios.get(config.apiAddress + '/app/finance/categories')
            .then(function (response) {
                that.setState({categories: response.data, loaded: true});
                that.props.preloaderHide();
            }).catch(function(error) {
            that.props.preloaderHide();
            that.props.alert('Nie udało się załadować ustawień');
        });
    };

    /**
     * @returns {[]}
     */
    renderCategories = () => {
        let categories = [];

        let that = this;
        Object.keys(this.state.categories).forEach(function(key) {
            if (that.state.categories[key] === 'limit') {
                return;
            }

            categories.push(
                <Label
                    key={that.state.categories[key]}
                    color={'120-main'}
                    class={'finance-category'}
                    text={that.props.elementName(that.state.categories[key])}
                    onCancel={() => that.removeCategory(that.state.categories[key])}
                />
            );
        });

        return categories;
    };

    /**
     * @param event
     */
    handleNewCategoryChange = (event) => {
        this.setState({newCategory: event.target.value});
    };

    /**
     * Add category
     */
    addCategory = () => {
        let categories = this.state.categories;
        let newCategory = this.state.newCategory;

        if (newCategory !== '') {
            categories.push(newCategory);
        }

        this.setState({categories: categories, newCategory: ''});
    };

    /**
     * Remove category
     */
    removeCategory = (name) => {
        let categories = this.state.categories;
        let newCategories = [];

        for (let x = 0; x < categories.length; x++) {
            if (categories[x] !== name) {
                newCategories.push(categories[x]);
            }
        }

        this.setState({categories: newCategories});
    };

    /**
     * Load events for week
     */
    saveEvent = () => {
        this.props.preloaderShow();
        let that = this;

        axios.put(config.apiAddress + '/app/finance/categories', that.state.categories)
            .then(function (response) {
                //I'm not hide poreloader because it will be hidden by FinanceScreen Container after categories will be reloaded.
                that.props.alert(TranslationService.trans(that.props.language, 'finance.actions.saved'));
                that.props.saveSettings();
                that.setState({loaded: false});
            }).catch(function(error) {
                that.props.preloaderHide();
                that.props.alert(TranslationService.trans(that.props.language, 'finance.actions.failed'));
            });
    };

    /**
     * @returns {*}
     */
    isOpen = () => {
        return (this.props.show ? ' imd-opened' : null);
    };

    /**
     * @returns {XML}
     */
    render() {
        return (
            <dialog className={"imd-dialog imd-bg-transparent-black" + this.isOpen()}>
                <div className="imd-dialog-body imd-bg-20-default imd-text-accent">
                    <header className="imd-text-contrast">
                        {TranslationService.trans(this.props.language, 'menu.settings')}
                        <span className="imd-icon imd-icon-xmark imd-dialog-close" onClick={() => {this.props.closeEvent(); this.setState({loaded: false});}} />
                    </header>

                    <div className="imd-dialog-content">
                        <div className="imd-form-control imd-bg imd-bg-20-default imd-border-color-accent">
                            {this.renderCategories()}
                        </div>

                        <FormGroup
                            label={TranslationService.trans(this.props.language, 'finance.new_category') + ':'}
                            color={'main'}
                            placeholder={TranslationService.trans(this.props.language, 'common.name')}
                            value={this.state.newCategory}
                            onChange={this.handleNewCategoryChange}
                            buttonText={TranslationService.trans(this.props.language, 'common.add')}
                            buttonOnClick={() => this.addCategory()}
                        />
                    </div>

                    <footer>
                        <Button
                            color={'accent'}
                            secondary={true}
                            text={TranslationService.trans(this.props.language, 'common.cancel')}
                            onClick={() => {this.props.closeEvent(); this.setState({loaded: false});}}
                        />
                        <Button
                            color={'main'}
                            text={TranslationService.trans(this.props.language, 'common.save')}
                            onClick={this.saveEvent}
                        />
                    </footer>
                </div>
            </dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        email: state.login.email,
        device: state.login.device,
        view: state.view,
        language: TranslationService.getLanguage(state.user)
    }
};

export const FinanceSettingsContainer = connect(mapStateToProps, {preloaderShow, preloaderHide, alert})(FinanceSettings);
